var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditDebitCardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 16,
    viewBox: "0 0 111 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1131_37891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 0.25H2.25C1.14543 0.25 0.25 1.14543 0.25 2.25V13.75C0.25 14.8546 1.14543 15.75 2.25 15.75H21.75C22.8546 15.75 23.75 14.8546 23.75 13.75V2.25C23.75 1.14543 22.8546 0.25 21.75 0.25Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.78773 5.91444C2.26459 5.62751 1.66754 5.39674 1 5.23659L1.028 5.11188H3.76498C4.13596 5.12489 4.43699 5.23651 4.53495 5.63071L5.12977 8.46659L5.31198 9.32073L6.97797 5.11188H8.77679L6.10288 11.2775H4.30397L2.78773 5.91444ZM10.1 11.2841H8.39883L9.46285 5.11188H11.1639L10.1 11.2841ZM16.2668 5.26277L16.0354 6.59559L15.8816 6.53004C15.5737 6.40525 15.1674 6.28054 14.6144 6.29371C13.9427 6.29371 13.6415 6.56277 13.6345 6.82546C13.6345 7.11441 13.9989 7.30484 14.5939 7.58725C15.574 8.02719 16.0286 8.56557 16.0218 9.26819C16.0081 10.5486 14.846 11.3761 13.0611 11.3761C12.2979 11.3694 11.5628 11.2181 11.1638 11.0476L11.4019 9.66205L11.6259 9.76066C12.1789 9.99071 12.5428 10.089 13.222 10.089C13.7118 10.089 14.2369 9.89838 14.2436 9.48488C14.2436 9.21565 14.0199 9.01851 13.3617 8.71646C12.7178 8.42087 11.8568 7.92848 11.8708 7.04198C11.8781 5.84042 13.0611 5 14.741 5C15.399 5 15.9312 5.13789 16.2668 5.26277ZM18.5278 9.09749H19.9417C19.8718 8.78889 19.5496 7.31147 19.5496 7.31147L19.4307 6.77964C19.3467 7.00943 19.1999 7.38373 19.2069 7.37056C19.2069 7.37056 18.6678 8.7429 18.5278 9.09749ZM20.6276 5.11188L22 11.284H20.4249C20.4249 11.284 20.2708 10.5748 20.2219 10.3581H18.0378C17.9746 10.5222 17.6808 11.284 17.6808 11.284H15.8958L18.4226 5.62399C18.5977 5.22342 18.906 5.11188 19.3118 5.11188H20.6276Z",
    fill: "#171E6C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1131_37891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51 0H31C29.8954 0 29 0.89543 29 2V14C29 15.1046 29.8954 16 31 16H51C52.1046 16 53 15.1046 53 14V2C53 0.89543 52.1046 0 51 0Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 13C40.7614 13 43 10.7614 43 8C43 5.23858 40.7614 3 38 3C35.2386 3 33 5.23858 33 8C33 10.7614 35.2386 13 38 13Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 13C46.7614 13 49 10.7614 49 8C49 5.23858 46.7614 3 44 3C41.2386 3 39 5.23858 39 8C39 10.7614 41.2386 13 44 13Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 4C42.2144 4.91221 43 6.36455 43 8.00037C43 9.63618 42.2144 11.0885 41 12.0007C39.7856 11.0885 39 9.63618 39 8.00037C39 6.36455 39.7856 4.91221 41 4Z",
    fill: "#FF5F00"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1131_37891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 0H60C58.8954 0 58 0.89543 58 2V14C58 15.1046 58.8954 16 60 16H80C81.1046 16 82 15.1046 82 14V2C82 0.89543 81.1046 0 80 0Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.764 13.3948V7.69336L81.9116 7.70246V9.27736L80.7387 10.5308L81.9116 11.7956V13.4039H80.039L79.0438 12.3058L78.0557 13.4081L71.764 13.3948Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4418 12.7692V8.32031H76.2141V9.3452H73.6632V10.0409H76.1532V11.0487H73.6632V11.732H76.2141V12.7692H72.4418Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1953 12.7691L78.2826 10.5421L76.1952 8.32031H77.8108L79.0863 9.73035L80.3654 8.32031H81.9116V8.35532L79.8687 10.5421L81.9116 12.706V12.7691H80.3499L79.0518 11.3449L77.767 12.7691H76.1953Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2374 2.63281H74.6834L75.5426 4.58366V2.63281H78.5624L79.0832 4.09438L79.6057 2.63281H81.9116V8.3342H69.7251L72.2374 2.63281Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7005 3.25L70.7264 7.69517H72.0803L72.4528 6.80501H74.4707L74.8429 7.69517H76.2304L74.2647 3.25H72.7005ZM72.8701 5.80744L73.4621 4.39236L74.0536 5.80744H72.8701Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2119 7.69508V3.25L78.115 3.25654L79.0943 5.98927L80.0799 3.25H81.9115V7.69508L80.7329 7.70551V4.65217L79.6204 7.69508H78.5446L77.4089 4.64174V7.69508H76.2119Z",
    fill: "#016FD0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1131_37891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.997 15.7499L108.999 15.7499C109.954 15.7581 110.738 14.9773 110.75 14.0042L110.75 2.0063C110.746 1.53569 110.559 1.08617 110.23 0.756802C109.901 0.428269 109.459 0.246149 108.997 0.250071L89.0006 0.250062C88.5411 0.246149 88.0986 0.428269 87.7703 0.756802C87.4411 1.08617 87.2538 1.53569 87.25 2.00426L87.25 13.9937C87.2538 14.4643 87.4411 14.9138 87.7703 15.2432C88.0986 15.5717 88.5411 15.7538 89.0028 15.7499H108.997ZM108.996 16.2499C108.996 16.2499 108.995 16.2499 108.995 16.2499L108.997 16.2499H108.996Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6124 16.0002H108.997C109.524 16.0046 110.031 15.7995 110.407 15.4301C110.782 15.0607 110.996 14.5573 111 14.0305V11.6719C107.456 13.7062 103.613 15.167 99.6124 16.0002Z",
    fill: "#F27712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.172 9.29595H109.32L108.36 8.02974H108.269V9.29595H107.574V6.15112H108.6C109.403 6.15112 109.866 6.48215 109.866 7.07801C109.866 7.56629 109.577 7.88077 109.055 7.98008L110.172 9.29595ZM109.146 7.10284C109.146 6.79663 108.915 6.63939 108.484 6.63939H108.269V7.59112H108.468C108.915 7.59112 109.146 7.4256 109.146 7.10284ZM105.141 6.15112H107.11V6.68077H105.836V7.38422H107.061V7.92215H105.836V8.77457H107.11V9.30422H105.141V6.15112ZM102.906 9.3787L101.4 6.14284H102.161L103.113 8.26146L104.073 6.14284H104.818L103.295 9.3787H102.923H102.906ZM96.6083 9.37043C95.549 9.37043 94.7214 8.65043 94.7214 7.71526C94.7214 6.80491 95.5656 6.06836 96.6249 6.06836C96.9228 6.06836 97.1711 6.12629 97.4773 6.2587V6.98698C97.2454 6.75916 96.9334 6.63139 96.6083 6.63112C95.9463 6.63112 95.4414 7.11112 95.4414 7.71526C95.4414 8.3525 95.938 8.80767 96.6414 8.80767C96.9559 8.80767 97.1959 8.70836 97.4773 8.46008V9.18836C97.1628 9.32077 96.898 9.37043 96.6083 9.37043ZM94.5063 8.33595C94.5063 8.94836 94.0014 9.37043 93.2732 9.37043C92.7435 9.37043 92.3628 9.18836 92.0401 8.77457L92.4952 8.3856C92.6525 8.66698 92.9173 8.80767 93.2483 8.80767C93.5628 8.80767 93.7863 8.61732 93.7863 8.36905C93.7863 8.22836 93.7201 8.12077 93.5794 8.03801C93.4251 7.96316 93.2645 7.90223 93.0994 7.85595C92.4456 7.64905 92.2221 7.4256 92.2221 6.98698C92.2221 6.47388 92.7021 6.08491 93.3311 6.08491C93.7283 6.08491 94.0842 6.20905 94.3821 6.44077L94.018 6.85457C93.8737 6.69635 93.6694 6.60622 93.4552 6.60629C93.1573 6.60629 92.9421 6.75526 92.9421 6.95388C92.9421 7.11939 93.0663 7.21043 93.4801 7.35112C94.2745 7.59939 94.5063 7.83112 94.5063 8.34422V8.33595ZM91.0883 6.15112H91.7835V9.30422H91.0883V6.15112ZM88.8538 9.30422H87.8276V6.15112H88.8538C89.9794 6.15112 90.7573 6.79664 90.7573 7.72353C90.7573 8.19526 90.5256 8.64215 90.1201 8.94008C89.7725 9.18836 89.3835 9.30422 88.8456 9.30422H88.8538ZM89.6649 6.93733C89.4332 6.75526 89.1683 6.68905 88.7132 6.68905H88.5228V8.77457H88.7132C89.1601 8.77457 89.4414 8.69181 89.6649 8.52629C89.9049 8.32767 90.0456 8.02974 90.0456 7.72353C90.0456 7.41732 89.9049 7.12767 89.6649 6.93733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4138 6.06836C98.5035 6.06836 97.7587 6.79664 97.7587 7.6987C97.7587 8.6587 98.4704 9.3787 99.4138 9.3787C100.341 9.3787 101.069 8.65043 101.069 7.72353C101.069 6.79664 100.349 6.06836 99.4138 6.06836Z",
    fill: "#F27712"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1131_37891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1131_37891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(29)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1131_37891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(58)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1131_37891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(87)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditDebitCardLogo);
export default __webpack_public_path__ + "static/media/credit-debit-card-logo.d500226e241aa18e5a1b67f1956e871c.svg";
export { ForwardRef as ReactComponent };